import { injectLocal } from '@vueuse/core';
import { PRODUCT_ID_REPOSITORY, PRODUCT_DATA_REPOSITORY } from '../constants/providers';

/**
 * * Product Data Injector
 * ! Dependency Injection of product data
 * Reduces complexity, removes prop drilling, increases performance
 * Plus, allows avoid unnecessary computed wraps
 */
export const useProduct = () => {
  const productId = injectLocal(PRODUCT_ID_REPOSITORY);
  if (typeof productId === 'undefined') {
    throw new TypeError('useProduct() is called without provider.');
  }

  const productData = injectLocal(PRODUCT_DATA_REPOSITORY) as Product;

  return {
    productId,
    productData,
  };
};
